import { ConfigService, Inject, Injectable } from '@produce8/pegasus';
import { ILogManager } from './log.manager.interface';
import { StaticEnvironmentKeysEnum } from '../../enum/static-environment/static-environment-keys.enum';
import { LogManager } from './log.manager.port';

@Injectable()
export class DiLogManager extends LogManager implements ILogManager {
  private _isDebug: boolean;
  constructor(
    @Inject(ConfigService) protected readonly configService: ConfigService
  ) {
    super({
      debug: configService.get<boolean>(StaticEnvironmentKeysEnum.DEBUG),
    });
    this._isDebug = this.configService.get<boolean>(
      StaticEnvironmentKeysEnum.DEBUG
    );
  }
  debug(message: string, ...args: any[]): void {
    if (this._isDebug) {
      console.debug(message, args);
    }
  }
  info(message: string, ...args: any[]): void {
    if (this._isDebug) {
      console.info(message, args);
    }
  }
  error(message: string, ...args: any[]): void {
    console.error(`P8_CUBE_HELPER_ERROR - ${message}`, args);
  }
}
